import { createDndDomain } from 'base/ui/dnd';
import { Page, PageState, Space, spaceDomain } from '../model';
import { pageAndAllSubpages } from '../model_helpers';

export type PagePosition = {
  parent: Page | Space;
  index: number;
};

export type PageSource = {
  page: PageState;
  from?: PagePosition & { mutable: Page };
};

export const pageDndDomain = createDndDomain<PageSource, PagePosition>({
  isSelfDrop: ({ from }, d) =>
    from != null &&
    from.parent === d.parent &&
    (from.index === d.index || from.index + 1 === d.index),
  isDropAllowed: ({ from }, d) => {
    if (from == null) return true;
    if (d.parent == null) return true; // can always drop at the top level
    if (spaceDomain.isMutable(d.parent)) return true; // can always drop in a space
    const fromPage = from.parent?.subPages[from.index];
    if (!fromPage) return false;
    const bad = pageAndAllSubpages(fromPage);
    return !bad.includes(d.parent);
  },
});
